export const zeroPad = (num, places) => String(num).padStart(places ?? 2, "0");

function getTargetIdFormParent(target, searchString) {
  let parent = target.parentElement;
  while (parent) {
    if (Array.from(parent.children).some((c) => c.id.includes(searchString))) {
      return Array.from(parent.children).find((c) => c.id.includes(searchString)).id;
    }

    parent = parent.parentElement;
  }

  return "";
}

export function getMultiAutoCompleteTargetId(event, searchString) {
  return event.currentTarget.id.length > 0
    ? event.currentTarget.id
    : getTargetIdFormParent(event.target, searchString);
}
